import styled from "styled-components";
import TextInput from "metabase/components/TextInput";

export const BreadcrumbsWrapper = styled.div`
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
`;

export const SearchInput = styled(TextInput)`
  margin-bottom: 1rem;
`;
